"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getOptions = getOptions;
exports.absoluteUrlForLocation = absoluteUrlForLocation;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var DEFAULT_OPTIONS = {
  apikey: null,
  enableInDevelopment: false,
  parselyCDN: "cdn.parsely.com",
  pixelHost: null
};

function getOptions(pluginOptions) {
  var options = (0, _extends2["default"])({}, DEFAULT_OPTIONS, {}, pluginOptions);
  return (0, _extends2["default"])({}, options, {
    isEnabled: isEnabled(options),
    parselyTrackPageViewExists: parselyTrackPageViewExists()
  });
}

function absoluteUrlForLocation(location) {
  return [window.location.protocol, "//", window.location.host, location.pathname, location.search, location.hash].join("");
}

function parselyTrackPageViewExists() {
  return typeof window !== "undefined" && typeof window.PARSELY !== "undefined" && typeof window.PARSELY.beacon !== "undefined" && typeof window.PARSELY.beacon.trackPageView !== "undefined";
}

function isEnabled(pluginOptions) {
  var shouldTrack = process.env.NODE_ENV === "production" || pluginOptions.enableInDevelopment;
  var hasValidApikey = typeof pluginOptions.apikey === "string" && pluginOptions.apikey.length > 0;
  return shouldTrack && hasValidApikey;
}